<script lang="ts" setup>
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";

defineProps<{
    breadcrumbs: {
        to?: string;
        label: string;
    }[];
}>();
</script>

<template>
    <ul v-if="breadcrumbs.length" class="flex items-center flex-grow-0 gap-2">
        <template v-for="(breadcrumb, index) in breadcrumbs" :key="index">
            <li v-if="index > 0">
                <FontAwesomeIcon :icon="faChevronRight" size="xs" />
            </li>
            <li>
                <NuxtLink
                    v-if="breadcrumb.to"
                    :to="breadcrumb.to"
                    class="hover:underline flex-shrink truncate"
                >
                    {{ breadcrumb.label }}
                </NuxtLink>
                <span v-else v-text="breadcrumb.label" />
            </li>
        </template>
    </ul>
</template>
